import { useEffect, useState } from 'react';
import AccountSetupButton from '../../../../common/AccountSetupButton';
import { MENU_LIST, OTHER_MENU_LIST } from '../DATA';
import { useNavigate } from 'react-router-dom';
import { BackButton2 } from '../../../../common/BackButton2';
import { createMenuAPI, updateMenuAPI } from '../../../../api/AccountSetup';
import ToastNotification from '../../../../common/ToastNotification';
import getCustomMenuEffect from '../../../../hooks/Menu';

interface menuProps {
  isSettings?: boolean | undefined;
}

const CreateMenu = (props: menuProps) => {
  const { isSettings } = props;
  const businessType = sessionStorage.getItem('businessType');
  const companyUuid = sessionStorage.getItem('companyUuid');
  const { menu, menuUuid, fetchData } = getCustomMenuEffect(companyUuid ? companyUuid : '');

  const navigate = useNavigate();

  const [checkedItems, setCheckedItems] = useState<string[]>([]);
  const [disable, setDisable] = useState(false);
  const [showComnt, setShowComnt] = useState(false);

  const handleCheckboxChange = (value: string) => {
    setCheckedItems((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
    );
    if (value === 'FAQ' && !checkedItems.includes(value)) {
      setShowComnt(true);
      setTimeout(() => setShowComnt(false), 2000);
    }
  };
  console.log("businessType in CreateMenu:", businessType);
  const handleGoBack = () => {
    navigate('/account-setup/create-profile');
  };

  const submitHandler = async () => {
    if (checkedItems.length > 0) {
      setDisable(true);
      const payload = {
        uuid: menuUuid,
        companyUuid: companyUuid ? companyUuid : '',
        menuSelected: checkedItems
      };
      const response = menuUuid ? await updateMenuAPI(payload) : await createMenuAPI(payload);
      if (response.ok) {
        setDisable(false);
        const data = await response.json();
        ToastNotification({
          message: data.message
        });
        if (!isSettings) {
          if (businessType === 'Hospitality' && checkedItems.includes('Services')) {
            navigate('/account-setup/create-product');
          } else {
            navigate('/account-setup/faq');
          }
        }
        fetchData();
      } else {
        setDisable(false);
        const errorData = await response.json();
        ToastNotification({
          message: errorData.message,
          type: 'error'
        });
      }
    } else {
      ToastNotification({
        message: 'Please select one item',
        type: 'error'
      });
    }
  };

  useEffect(() => {
    if (menu.length > 0) {
      setCheckedItems(menu);
    }
  }, [JSON.stringify(menu)]);

  return (
    <div className="flex flex-col flex-1 bg-[#1E1E1E] rounded-lg lg:px-0 md:pt-3 lg:pt-6 p-2 overflow-y-auto">
      {!isSettings && (
        <>
          <h2 className="lg:text-base md:text-base text-[14px] font-normal md:mb-[5px] mb-1 lg:ml-9 ml-[4px] md:ml-1">
            STEP 2
          </h2>
          <div className="flex ml-[4px] md:ml-1 ">
            <div className="lg:mt-1 md:mt-2 mt-1 mr-1 sm:pt-[3px] lg:pt-0">
              <BackButton2 onClick={handleGoBack} />
            </div>
            <h1 className="h-[39px] lg:ml-0 lg:mt-2 md:mt-[14px] mt-1 lg:mb-[20px] mb-[14px] text-[16px] sm:leading-[29.18px] md:text-base lg:text-base  font-medium">
              Configure chatbot interactions
            </h1>
          </div>
        </>
      )}
      {isSettings && (
        <>
          <div className="flex ml-[4px] md:ml-1">
            <h1
              className="h-[39px] lg:ml-0 lg:mt-2 md:mt-1 mt-1 lg:mb-[10px] mb-[14px] text-[16px] sm:leading-[29.18px] md:text-base lg:text-base  font-bold md:pl-4
             duration-500 ease-in-out"
            >
              Configure chatbot interactions
            </h1>
          </div>
        </>
      )}
      <div className="lg:ml-9 ml-[4px] md:ml-1 mb-0">
        {(businessType === 'Hospitality' ? MENU_LIST : OTHER_MENU_LIST).map(
          (menu: any, ind: number) => (
            <div key={ind} className="flex items-center space-x-2 mb-3">
              <input
                type="checkbox"
                id={menu}
                className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                checked={checkedItems.includes(menu)}
                onChange={() => handleCheckboxChange(menu)}
              />
              <label
                htmlFor={menu}
                className="text-[#FFFFFF] text-[13px] sm:text-[16px] lg:text-sm font-normal"
              >
                {menu}
              </label>
            </div>
          )
        )}
        {showComnt && (
          <span className="absolute left-[50%] sm:left-[50%] md:left-[50%] lg:left-[59%] bottom-10 transform -translate-x-1/2 bg-[#626262] text-white text-[10px] md:text-[16px] py-1 px-2 rounded animate-popup">
            When you add a question to the FAQ, it will appear in the chatbot.
          </span>
        )}
      </div>
      <div className="flex justify-end items-end mt-auto lg:mb-2 ">
        <AccountSetupButton
          isFormValid={true}
          disable={disable}
          btnText={isSettings ? 'Update' : 'Next'}
          textColor="#FFFFFF"
          backGroundColor="#006BEA"
          onClick={() => submitHandler()}
        />
      </div>
    </div>
  );
};

export default CreateMenu;
